import { render } from "./update_acceptance.vue?vue&type=template&id=b02865e4"
import script from "./update_acceptance.vue?vue&type=script&lang=js"
export * from "./update_acceptance.vue?vue&type=script&lang=js"

import exportComponent from "/var/deploy/beta/web_head/releases/20260724220351/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__